// extracted by mini-css-extract-plugin
export default {"contactButton":"ContactButton_contactButton__EFLi6","contactButtonIcon":"ContactButton_contactButtonIcon__vXFTe","contactButtonLabel":"ContactButton_contactButtonLabel__hHalM"};